import { headers, parseJSON } from '../../apiUtils';
//import RequestWatcher from '../request-watcher';
//import store from '../store';
//import { PollingIntervals } from '../constants';

export function fetchAgentSurveyFormQuestions() {
    const path = `/api/AgentSurveyV3/surveyform-questions`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

export function fetchReasonForContact() {
    const path = `/api/AgentSurveyV3/reason-for-contact`;

    return fetch(path, {
        headers: headers(),
        method: 'GET'
    }).then(parseJSON);
}

//export function fetchTicketsToBeSurveyedCount() {
//    const path = `/api/AgentSurveyV3/tickets-to-survey-count`;

//    return fetch(path, {
//        headers: headers(),
//        method: 'GET'
//    }).then(parseJSON);
//}

//export function fetchTicketToBeSurveyed() {
//    const path = `/api/AgentSurveyV3/ticket-to-survey`;

//    return fetch(path, {
//        headers: headers(),
//        method: 'GET'
//    }).then(parseJSON);
//}

export function _submitAgentSurvey(surveyResult) {
    const url = `/api/AgentSurveyV3/submit`;
    return fetch(url, {
        headers: headers(),
        body: JSON.stringify(surveyResult),
        method: 'POST'
    });
}